export const COUNTDOWN_INITIAL_TIME_IN_SECONDS = 120;
